import React from "react";

import { FormHelperText, TextField } from "@mui/material";

import { getIdsArray, isValidJobID } from "../../services/utils/validator";

type JobIDsComponentProps = {
  setJobIds: (ids: string[]) => void;
};

const JobIDsFilter: React.FC<JobIDsComponentProps> = ({ setJobIds }) => {
  const [ids, setIds] = React.useState("");
  const [idError, setIdError] = React.useState(true);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const idArray = getIdsArray(value);
    const isValid = idArray.every(isValidJobID);

    setJobIds(isValid ? idArray : []);
    setIdError(!isValid);
    setIds(value);
  };

  return (
    <>
      <TextField
        label="Job IDs"
        multiline
        minRows={8}
        placeholder="Enter comma-seperated Job IDs i.e. 66bb41a8eada85805334db8f, 66bb41a2eada85805334db8d"
        fullWidth
        value={ids}
        data-testid="job-id-input"
        onChange={handleChange}
      />
      {idError && <FormHelperText error={true}>Invalid list of Job IDs.</FormHelperText>}
    </>
  );
};
export default JobIDsFilter;
